import { AxiosInstance } from 'axios';
import { IInvoiceListParams, IInvoiceService } from './IInvoiceService';

export class InvoiceService implements IInvoiceService {

    constructor(private readonly axios: AxiosInstance) {
    }

    public readonly getInvoice = (hash: string, mode: string|undefined) => {
        return this.axios.get(`/api/invoice/${hash}`, {
            params: {
                activity: true,
                mode,
                time: new Date().getTime()
            }
        });
    };

    public readonly getInvoicePdf = (pdf_url: string) => {
        return this.axios.get(pdf_url);
    };

    public readonly getInvoiceList = async (hash: string, source: string) => {
        const response = await this.axios.get(`/businessinvoices/${hash}${source}`);
        return response;
    };

    public readonly retrieveSuppliersFeed = async (supplierId: string, clientId: string, country: string, product: string, state: string) => {
        return this.axios.get(`/myob/link/${supplierId}/${clientId}?country=${country}&product=${product}&state=${state}`).then(res => {
            return res.data;
        });
    };

    public readonly createSupplierFeed = async (invoice: any, businessId: string, country: string, product: string, serialNumber: string) => {
        const params = {
            invoice,
            business: {
                id: (businessId && businessId !== ' ') ? businessId : undefined,
                country: (country && country !== ' ') ? country : undefined,
                serialNumber: (serialNumber && serialNumber !== ' ') ? serialNumber : undefined,
                product: (product && product !== ' ') ? product : undefined
            }
        };
        return this.axios.post(`/myob/link`, params).then(res => {
            return res.data;
        });
    };

    public readonly removeSupplierFeed = async (supplierHash: string, clientHash: string) => {
        return this.axios.delete(`/myob/link/${supplierHash}/${clientHash}`).then(res => {
            return res.data;
        });
    };

    public readonly submitToInTray = async (hash: string, supplierId: string, clientId: string, invoice: any) => {
        return this.axios.post(`/invoice/hash/${hash}/supplier/${supplierId}/client/${clientId}`, {
            country: invoice.company.country,
            product: invoice.consumer,
            state: invoice.state
        }).then(res => {
            return res.data;
        });
    };

    public readonly login = async (hash: string) => {
        return this.axios.get(`/login/${hash}`).then(res => {
            return res.data;
        });
    };

    public readonly getCompanyList = async () => {
        return this.axios.get(`/companies`).then(res => {
            return res.data;
        });
    };

    public readonly closeSelectCompany = async (hash: string) => {
        return this.axios.get(`/closeselectcompany/${hash}`).then(res => {
            return res.data;
        });
    };

    public readonly postInvoiceList = (params: IInvoiceListParams): Promise<any> => {
        return this.axios.post('/createbulkpayment', params).then(res => {
            return res.data;
        });
    };

    public readonly getOIPDetails = (cdfGuid) => {
        return this.axios.get(`/oip-config?cdfGuid=${cdfGuid}`).then(res => {
            return res.data;
        });
    };

}
